import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

// Número do período com seta contra o período anterior. `menorMelhor` inverte a cor
// (desconto e custo: subir é sinal de alerta, não de sucesso).
export default function Kpi({ rotulo, valor, atual, anterior, dica, destaque, menorMelhor = false, icone: Icone, e2e }) {
  let variacao = null;
  if (anterior != null && atual != null) {
    if (Number(anterior) > 0) variacao = Math.round(((Number(atual) - Number(anterior)) / Number(anterior)) * 100);
    else if (Number(atual) > 0) variacao = "novo";
  }
  const subiu = variacao === "novo" || variacao > 0;
  const bom = variacao === 0 || variacao === null ? null : menorMelhor ? !subiu : subiu;
  const Seta = variacao === 0 ? Minus : subiu ? ArrowUpRight : ArrowDownRight;
  return (
    <div className={`rounded-xl border p-4 ${destaque || "bg-card"}`} data-e2e={e2e}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{rotulo}</p>
        {Icone && <Icone className="w-4 h-4 text-muted-foreground" />}
      </div>
      <p className="text-2xl font-black tabular-nums mt-0.5 leading-tight">{valor}</p>
      <div className="flex items-center gap-2 mt-0.5 min-h-[1rem]">
        {variacao !== null && (
          <span className={`text-[11px] flex items-center gap-0.5 font-semibold ${bom === null ? "text-muted-foreground" : bom ? "text-emerald-600 dark:text-emerald-400" : "text-red-500"}`}>
            <Seta className="w-3 h-3" />{variacao === "novo" ? "novo" : `${variacao > 0 ? "+" : ""}${variacao}%`}
          </span>
        )}
        {dica && <span className="text-[11px] text-muted-foreground truncate">{dica}</span>}
      </div>
    </div>
  );
}
